import React from 'react';
import { Link } from 'react-scroll';
import './Navbar.css';

export const Navbar = () =>{
 return (
    <>
    <nav className='navbar navbar-expand-lg'>
      <div className="left">
      <Link activeClass='active' to="home" spy={true} smooth={true} offset={-100} duration={500} className='desktopMenuListItemR'>Aashish Lal</Link>
      </div>
      <div className="right desktopMenu">
      <Link activeClass='active' to="home" spy={true} smooth={true} offset={-100} duration={500} className='desktopMenuListItem'>Home</Link>
      <Link activeClass='active' to="about" spy={true} smooth={true} offset={-140} duration={500} className='desktopMenuListItem'>About</Link>
      <Link activeClass='active' to="project" spy={true} smooth={true} offset={-170} duration={500} className='desktopMenuListItem'>Projects</Link>
      <Link activeClass='active' to="contact" spy={true} smooth={true} offset={-135} duration={500} className='desktopMenuListItem'>Contact</Link>
      </div>
    </nav>
    </>
 )};